import { gaGetClientIdSync } from "utils/analytics"
import { ErrorResponse } from "utils/interfaces"
import { GetBookingDetailsResponse, BookingDetails } from "modules/BookingCommon/common/interfaces"
import { getTildaUtm } from "utils/utm"
import { UserAccount } from "utils/UserAccount"
import { httpClient } from "utils/infrastructure/httpClient"

interface ApplyDiscountResponse {
    price: number
    price_usd: number
    discount: string | null
}

export function getBookingDetails(bookingHash: string) {
    return httpClient.post<GetBookingDetailsResponse | ErrorResponse>("get-booking-details", {
        booking_hash: bookingHash,
        client_name: UserAccount.name,
        client_email: UserAccount.email,
        ga_client_id: gaGetClientIdSync(),
        utm: getTildaUtm(),
    })
}

export function fetchBookingDetails(bookingHash: string) {
    return httpClient.post<BookingDetails & ErrorResponse>("booking-details", {
        booking_hash: bookingHash,
        client_name: UserAccount.name,
        client_email: UserAccount.email,
        ga_client_id: gaGetClientIdSync(),
        utm: getTildaUtm(),
    })
}

export function applyDiscount(bookingId: number, discount: number | undefined) {
    return httpClient.post<ApplyDiscountResponse & ErrorResponse>(
        `booking/${bookingId}/apply-discount`,
        {
            discount,
        }
    )
}
